module.exports = __webpack_public_path__ + "img/maobi.46397303.png";